import { AccountClosureModal } from '@viastud/ui/shared/account-closure-modal'
import type { UserDto } from '@viastud/ui/shared/edit-profile'
import type { BaseFormModalProps } from '@viastud/ui/types/base-form-modal'

interface IEditUserModalProps extends BaseFormModalProps {
  user: UserDto
}

export const DeleteChildModal = ({ refresh, user }: IEditUserModalProps) => {
  return (
    <AccountClosureModal
      id={user.id}
      name={`${user.firstName} ${user.lastName}`}
      onClosed={refresh}
    />
  )
}
